import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = ["href"];
const _hoisted_2 = { class: "table" };
const _hoisted_3 = { class: "title" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'CategoryButton',
    props: {
        image: {},
        title: {},
        href: {},
        barColor: {},
        bottomrighticon: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("a", {
                href: _ctx.href != null ? _ctx.href : _ctx.$router.path
            }, [
                _createElementVNode("div", {
                    class: "ad-button",
                    style: _normalizeStyle('background-image:url(' + _ctx.bottomrighticon + '); ' + 'background-color: ' + (_ctx.barColor ? _ctx.barColor : 'unset'))
                }, [
                    _createElementVNode("div", {
                        class: "image",
                        style: _normalizeStyle('background-image: url(' + _ctx.image + ')')
                    }, null, 4),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "title-col v-col-10" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, { class: "arrow-col v-col-2" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createElementVNode("img", {
                                            class: "arrow",
                                            src: _imports_0
                                        }, null, -1)
                                    ])),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ])
                ], 4)
            ], 8, _hoisted_1));
        };
    }
});
